import { ThemeChild } from '@api';
import { type AppTableFeatures } from '@design/components/table';
import { ColumnDef } from '@tanstack/react-table';
import { ThemeLogoIcon } from '@terminal/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';
import { TFunction } from 'i18next';
import { CSSProperties } from 'react';

import styles from './ParentCategoryTable.module.scss';

export const COUNT_COLUMN_ID = 'count';
const NAME_COLUMN_ID = 'name';

export const getColumns = ({
  t,
  total,
}: {
  t: TFunction;
  total: number;
}): ColumnDef<AppTableFeatures, ThemeChild>[] => {
  return [
    {
      id: NAME_COLUMN_ID,
      header: t(
        'widget:assetOverview.knowledgeGraph.themeExposure.tabs.parentCategory.investmentTheme',
        {
          count: total,
        }
      ),
      cell: props => {
        return (
          <div className={styles.themeWrapper}>
            <ThemeLogoIcon
              name={props.row.original.theme.name}
              logo_url={props.row.original.theme.logo_url}
              type="industry"
              size={32}
              fallbackIcon={
                <div
                  className={styles.fallbackLogo}
                  style={{ '--logo-size': '32px' } as CSSProperties}
                >
                  {props.row.original.theme.name.charAt(0).toUpperCase()}
                </div>
              }
            />
            <div>{props.row.original.theme.name}</div>
          </div>
        );
      },
      accessorFn: row => row.theme.name,
    },
    {
      id: COUNT_COLUMN_ID,
      header: t(
        'widget:assetOverview.knowledgeGraph.themeExposure.tabs.parentCategory.companiesInTheme'
      ),
      cell: props => {
        return <div>{props.row.original.company_count}</div>;
      },
      accessorFn: row => row.company_count,
    },
  ];
};
